var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hotel-changes"},[_c('div',{staticClass:"hotel-changes-container"},[_c('list-hotel-pending-changes')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }